function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const PERIODS = ['today', 'last24Hours', 'thisWeek', 'last7Days', 'thisMonth', 'last30Days', 'thisYear', 'allTime'];
export class BaseAnalyticsService {
  constructor(config) {
    _defineProperty(this, "siteId", void 0);
    _defineProperty(this, "apiKey", void 0);
    _defineProperty(this, "apiEndpoint", void 0);
    _defineProperty(this, "isPublic", void 0);
    if (this.constructor === BaseAnalyticsService) {
      throw new Error('Cannot instantiate an abstract class');
    }
    this.siteId = config.site_id;
    this.apiKey = config.api_key;
    this.apiEndpoint = config.api_endpoint;
    this.isPublic = config.is_public;
    return this;
  }
}